import { styled } from 'styled-components'
import WizrText from '../WizrText'
import WizrButton from '../WizrButton'
import WizrFlexSpacing from '../WizrFlexSpacing'
import { useState } from 'react'
import WizrFlexLayout from '../WizrFlexLayout'
import { Form } from 'antd'

interface IConfirmationForm {
 
  onConfirm?: (agentType: 'SingleAgent' | 'Supervisor') => void
 
}

const TextContainer = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: left;
  text-align: left;
`

const TypeContainer = styled.div`
  display: flex;
  gap: 16px;
  margin: 16px 0;
  justify-content: center;
`

const TypeOption = styled.div<{ selected: boolean }>`
  border: 2px solid ${props => props.selected ? '#1D1F22' : '#E5E5E5'};
  width: Fixed (192px)px;
  height: Hug (42px)px;
  padding: 6px 50px;
  gap: 10px;
  border-radius: 32px ;
  opacity: 0px;

  
  &:hover {
    border-color:#1D1F22;
    cursor: pointer;
  }
`


const AgentTypeSelection = ({
  onConfirm,
}: IConfirmationForm): JSX.Element => {
  const [selectedType, setSelectedType] = useState<'SingleAgent' | 'Supervisor' | null>(null);
  const [form] = Form.useForm()

  const handleConfirm = () => {
    if (selectedType) {
      onConfirm?.(selectedType);
    }
  };


  return (
    <WizrFlexSpacing background='#FFF' style={{width: '100%'}}>
      <Form
       form={form}
       name='basic'
       initialValues={{ remember: true }}
       onFinish={handleConfirm}
       onFinishFailed={() => null}
       autoComplete='off'
      >
      <TextContainer>
        <WizrText type='body2' textColor='#707276'>Select Type</WizrText>
        <Form.Item name='agent_type' rules={[{required:true,message:'Please select an agent type before proceeding '}]}>
        <TypeContainer>        

          <TypeOption 
            selected={selectedType === 'Supervisor'} 
            onClick={() => {
              setSelectedType('Supervisor')
              form.setFieldsValue({ agent_type: 'Supervisor' })
            }}
          >
            <WizrText type='body2'>Multi Agent</WizrText>
          </TypeOption>
          <TypeOption 
            selected={selectedType === 'SingleAgent'} 
            onClick={() => {
              setSelectedType('SingleAgent')
              form.setFieldsValue({ agent_type: 'SingleAgent' })
            }}
          >
            <WizrText type='body2'>Single Agent</WizrText>
          </TypeOption>
        </TypeContainer>
        </Form.Item>
        <WizrText type='body3' textColor='#999B9F'>
          Select the type: <strong>Multi Agent</strong> or <strong>Single Agent</strong>. Once set, this choice cannot be changed.
        </WizrText>
        <WizrText type='body3' textColor='#999B9F'>
          In Multi Agent mode, you can manage multiple sub agents, each with their own set of tools, along with a supervisor agent overseeing them. In Single Agent mode, you can configure one agent and add multiple tools to it.
        </WizrText>
        <WizrText type='body3' textColor='#999B9F'>
          Please choose carefully as this decision is final.
        </WizrText>        
      
      </TextContainer>

      <WizrFlexLayout flexDirection='row'  justifyContent='flex-end' background='#FFF' >
        <WizrButton text={'Proceed'} onClick={form.submit} style={{borderRadius: '20px',margin: '5px'}}/>
      </WizrFlexLayout>
      </Form>

    </WizrFlexSpacing>
  )
}

export default AgentTypeSelection
